<script setup>
import { onMounted } from 'vue'
import { GlobalHeader, BreadCrumb, NewsList, SideMenu, Footer } from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/index'

const props = defineProps({
  breadCrumbList: {
    type: Array,
    default: () => []
  }
})
const { $ads } = useNuxtApp()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
useCustomJsonld(props.breadCrumbList)
onMounted(() => {
  $ads.init(adsConfig)
})
</script>

<template>
  <div>
    <GlobalHeader :is-web-view-prop="isWebViewFlag" />
    <div :class="['content', { 'app-view': isWebViewFlag }]">
      <BreadCrumb
        v-if="breadCrumbList.length > 0"
        :bread-crumb-list="breadCrumbList"
        :is-web-view-prop="isWebViewFlag"
      />
      <div class="main-sub-container">
        <main>
          <slot />
          <slot name="ads-atf">
            <div
              id="2.5web_golf_pref_atf"
              class="ads-atf"
            />
          </slot>
          <slot name="main-center" />
          <slot name="ads-btf">
            <div
              id="2.5web_golf_pref_btf1"
              class="ads-btf"
            />
          </slot>
          <slot name="main-bottom" />
        </main>
        <sub>
          <slot name="ads-btf">
            <div
              v-if="!isWebViewFlag"
              id="2.5web_golf_pref_btf2"
              class="ads-btf"
            />
          </slot>
          <NewsList
            class="news-list"
            :is-web-view-prop="isWebViewFlag"
            :app-view-show="false"
          />
          <ContentRecommend :is-web-view-prop="isWebViewFlag" />
          <AreaLink />
          <SideMenu
            :is-web-view-prop="isWebViewFlag"
            :app-view-show="false"
          />
          <slot name="ads-btm">
            <div
              id="2.5web_golf_pref_btm"
              class="ads-btm"
            />
          </slot>
        </sub>
      </div>
    </div>
    <Footer :is-web-view-prop="isWebViewFlag" />
    <StickyAd />
  </div>
</template>

<style>
html {
  scroll-behavior: unset;
}
</style>

<style scoped>
.content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 54px;
  max-width: 1100px;
  margin: 0 auto 0;
  padding-left: 10px;
  padding-right: 10px;
}
.content.app-view {
  padding-top: 15px;
}

.main-sub-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

main {
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  .news-list {
    display: none;
  }
}

sub {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.ads-atf {
  min-height: 50px;
  margin: 0px auto 10px;
  text-align: center;
  position: relative;
}

.ads-btf {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}

.ads-btm {
  min-height: 250px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}

@media screen and (min-width: 830px) {
  .content {
    padding-top: 120px;
    margin-top: 15px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .main-sub-container {
    flex-direction: row;
    gap: 30px;
  }

  main {
    width: calc(100% - 330px);
    .news-list.show-in-main {
      display: block;
    }
  }

  sub {
    width:  300px;
    align-self: flex-start;
    .news-list.show-in-main {
      display: none;
    }
  }
}
</style>
